exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_infoTable_RUZPjObnuHJKpHSP2FOnm {\n  display: table;\n}\n.IA_infoTableRow_32gtSbAoCoIgYVuF0_x1oc a{\n  text-decoration: none;\n}\n.IA_infoTableRow_32gtSbAoCoIgYVuF0_x1oc a:hover{\n  text-decoration: underline;\n}\n.IA_infoTableRow_32gtSbAoCoIgYVuF0_x1oc {\n  display: table-row;\n  height: 22px;\n  width: auto;\n}\n.IA_birthdayContainer_39sODGr93LDikKWl2wm9jc{\n  width: 100%;\n  display: inline-block;\n} \n.IA_birthdayList_e3PL21XwwwFU2GLz9Hbqi {\n  display: inline-block;\n}\n.IA_infoTableText_2wG24UgYiXa11UsoILKvf5{\nfont-weight: 100;\n}", ""]);

// Exports
exports.locals = {
	"IA_infoTable": "IA_infoTable_RUZPjObnuHJKpHSP2FOnm",
	"IA_infoTableRow": "IA_infoTableRow_32gtSbAoCoIgYVuF0_x1oc",
	"IA_birthdayContainer": "IA_birthdayContainer_39sODGr93LDikKWl2wm9jc",
	"IA_birthdayList": "IA_birthdayList_e3PL21XwwwFU2GLz9Hbqi",
	"IA_infoTableText": "IA_infoTableText_2wG24UgYiXa11UsoILKvf5"
};